var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgWhatsAppIcon = function SvgWhatsAppIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24.241,
    height: 24.408,
    viewBox: "0 0 24.241 24.408",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M199.462,289.689c-.277-.166-1.775-.943-2.052-1.054s-.5-.166-.666.111c-.222.277-.832.943-1,1.165s-.388.222-.666.056a7.91,7.91,0,0,1-2.385-1.609,8.225,8.225,0,0,1-1.609-2.163c-.166-.333,0-.444.166-.61a4.235,4.235,0,0,0,.5-.5,1.573,1.573,0,0,0,.333-.5.644.644,0,0,0,0-.555c-.055-.166-.61-1.664-.832-2.274s-.5-.5-.666-.555c-.166,0-.388-.056-.555-.056a1.157,1.157,0,0,0-.832.333,3.415,3.415,0,0,0-1.165,2.5,5.937,5.937,0,0,0,1.109,3.162c.166.222,2,3.439,4.992,4.771,3.051,1.331,3.051.943,3.606.888a3.124,3.124,0,0,0,2.108-1.387,2.721,2.721,0,0,0,.222-1.442c-.111-.056-.277-.111-.61-.277Zm-5.547,7.156a9.681,9.681,0,0,1-5.436-1.664l-3.828,1.22,1.22-3.661a10,10,0,0,1-1.886-5.825,9.874,9.874,0,1,1,9.929,9.929Zm0-21.745a11.884,11.884,0,0,0-11.871,11.871,11.689,11.689,0,0,0,1.72,6.157l-2.163,6.379,6.6-2.108a11.891,11.891,0,1,0,5.714-22.3Z",
    transform: "translate(-181.6 -275.1)",
    fill: "#02c5e3",
    fillRule: "evenodd"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWhatsAppIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/whatsAppIcon.92cf7819.svg";
export { ForwardRef as ReactComponent };